"use client";

import { TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import type { Subcategory } from "@/components/ProductCardListWrapper/variants/ProductCardListBySearchTab/types";
import { cn } from "@/lib/utils";
import { sanitizeTabValue } from "@/utils/sanitizeTabValue";

type SubcategoryTabBarProps = {
  subcategories?: Subcategory[] | null;
  categoryLabel: string;
  children: (subcategory: Subcategory) => React.ReactNode;
};

export function SubcategoryTabBar({
  subcategories,
  categoryLabel,
  children,
}: SubcategoryTabBarProps) {
  const subs = subcategories ?? [];

  return (
    <>
      <TabsList className="overflow-x-scroll justify-start h-auto py-5 gap-2 pl-2">
        {subs.map((subcategory) => {
          const sanitizedSubcategoryValue = sanitizeTabValue(
            subcategory.subcategoryLabel,
          );
          if (subcategory.subcategoryLabel.trim() === "") {
            return null;
          }

          return (
            <TabsTrigger
              key={sanitizedSubcategoryValue}
              value={sanitizedSubcategoryValue}
              className={cn(
                "grow-0 rounded-[0.25rem] no-underline py-1 px-2",
                "text-primary text-sm font-bold bg-putty-400",
                "hover:bg-primary hover:text-white",
                "data-[state=active]:bg-primary-500",
                "data-[state=active]:text-white data-[state=active]:hover:text-white",
                "first:rounded-[0.25rem] last:rounded-[0.25rem]",
              )}
            >
              {subcategory.subcategoryLabel}
            </TabsTrigger>
          );
        })}
      </TabsList>

      {subs.map((subcategory) => {
        if (subcategory.subcategoryLabel.trim() === "") {
          return null;
        }
        const sanitizedSubcategoryValue = sanitizeTabValue(
          subcategory.subcategoryLabel,
        );
        return (
          <TabsContent
            key={`${categoryLabel}-${sanitizedSubcategoryValue}`}
            value={sanitizedSubcategoryValue}
            className={cn("mt-0")}
          >
            {children(subcategory)}
          </TabsContent>
        );
      })}
    </>
  );
}
